module.exports = __webpack_public_path__ + "static/media/search-contact.c3dcba17.svg";